import { Phone, Mail, MapPin, MessageCircle, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "../data/site";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="bg-[#0A192F] text-white py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="slash-divider"></span>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#0EA5E9]">Contact</span>
          </div>
          <h1 className="font-head font-black text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-3xl">
            Talk to a spares specialist.
          </h1>
          <p className="mt-5 text-white/70 max-w-2xl text-lg">
            Walk in, call, WhatsApp or email — we&rsquo;ll get back the same working day.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-6">
            <div className="bg-white border border-[#E2E8F0] p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#0A192F] text-[#0EA5E9] flex items-center justify-center shrink-0"><MapPin size={20} /></div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#94A3B8]">Address</div>
                  <div className="text-[#0A192F] mt-1 leading-relaxed">{COMPANY.address}</div>
                </div>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-6">
              <a href={COMPANY.phoneHref} className="bg-white border border-[#E2E8F0] hover:border-[#0EA5E9] p-6 transition-colors block" data-testid="contact-phone">
                <div className="w-12 h-12 bg-[#0A192F] text-[#0EA5E9] flex items-center justify-center mb-3"><Phone size={20} /></div>
                <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#94A3B8]">Phone</div>
                <div className="font-head font-bold text-[#0A192F] mt-1">{COMPANY.phone}</div>
              </a>
              <a href={COMPANY.emailHref} className="bg-white border border-[#E2E8F0] hover:border-[#0EA5E9] p-6 transition-colors block" data-testid="contact-email">
                <div className="w-12 h-12 bg-[#0A192F] text-[#0EA5E9] flex items-center justify-center mb-3"><Mail size={20} /></div>
                <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#94A3B8]">Email</div>
                <div className="font-head font-bold text-[#0A192F] mt-1 break-all">{COMPANY.email}</div>
              </a>
            </div>

            <div className="bg-[#0A192F] text-white p-6">
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0EA5E9] mb-3">Quick Connect</div>
              <div className="flex flex-wrap gap-3">
                <a href={COMPANY.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-[#25D366] px-4 py-3 text-xs font-bold uppercase tracking-[0.18em]" data-testid="contact-whatsapp">
                  <MessageCircle size={14} /> WhatsApp
                </a>
                <a href={COMPANY.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-[#0EA5E9] px-4 py-3 text-xs font-bold uppercase tracking-[0.18em] transition-colors" data-testid="contact-instagram">
                  <Instagram size={14} /> Instagram
                </a>
                <a href={COMPANY.facebook} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-white/10 hover:bg-[#1877F2] px-4 py-3 text-xs font-bold uppercase tracking-[0.18em] transition-colors" data-testid="contact-facebook">
                  <Facebook size={14} /> Facebook
                </a>
              </div>
              <div className="mt-5 text-xs uppercase tracking-[0.2em] text-white/50">
                Prop <span className="text-white">{COMPANY.proprietor}</span> · Davangere
              </div>
            </div>

            <Link
              to="/enquiry"
              className="block w-full text-center bg-[#0EA5E9] hover:bg-[#0284C7] text-white px-5 py-4 font-bold text-xs uppercase tracking-[0.18em] transition-colors"
              data-testid="contact-cta-enquiry"
            >
              Send a Detailed Enquiry →
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="aspect-[4/3] bg-[#F1F5F9] border border-[#E2E8F0]">
              <iframe
                title="Kashetter Industrial Essentials Location"
                src={COMPANY.mapsEmbed}
                className="w-full h-full"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
            <div className="mt-4 text-xs uppercase tracking-[0.2em] text-[#94A3B8]">
              Davangere · Karnataka · India
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
